import { createActionsHook } from 'src/lib/sweetState';

import { LocalStore } from './LocalStore';

export const useLocalActions = createActionsHook(LocalStore);
